// ChannelGate owns the copy that is sent when no organization email template
// is selected. Read it from the same endpoint Console uses so the editor and
// sender cannot silently drift.

export function getChannelGateBase() {
    const configured = process.env.REACT_APP_CHANNEL_GATE_URL || '';
    if (!configured) throw new Error('REACT_APP_CHANNEL_GATE_URL is not set — cannot read the platform email template');
    return configured.replace(/\/+$/, '');
}

/**
 * Platform copy for one template type. ChannelGate refuses an unknown type with
 * a 400 rather than quietly returning invitation copy — the editor used to show
 * invitation subject and body whatever type an author picked, and a silent
 * substitution here would hide that same bug one layer down.
 */
export async function getDefaultTemplate(templateType) {
    const query = templateType ? `?type=${encodeURIComponent(templateType)}` : '';
    const response = await fetch(`${getChannelGateBase()}/outreach/email-template${query}`);
    if (!response.ok) throw new Error(`getDefaultTemplate(${templateType || 'invitation'}) failed (${response.status})`);
    return response.json();
}

// Kept for callers written before types existed. It passes no type on purpose,
// so the request it makes is byte-for-byte the one it always made and the
// server's own default decides.
export function getDefaultInvitationTemplate() {
    return getDefaultTemplate();
}
